import apiClient from '../../services/apiClient';

/* ═══════════════════ GCS Bucket API ═══════════════════ */

export interface BucketFileInfo {
  name: string;
  size: number;
  contentType: string;
  category: string;
  created: string;
  uploadedBy?: string;
  uploadedByName?: string;
}

export interface BucketCategoryStats {
  category: string;
  fileCount: number;
  totalBytes: number;
}

export interface BucketStatsResponse {
  bucketName: string;
  totalFiles: number;
  totalBytes: number;
  categories: BucketCategoryStats[];
  recentFiles: BucketFileInfo[];
  monthlyCostUSD: number;
  costBreakdown: Record<string, number>;
}

export async function fetchBucketStats(): Promise<BucketStatsResponse> {
  const res = await apiClient.get('/api/dev/gcs-bucket');
  return res.data.data;
}

/* ═══════════════════ Inbox Monitor API ═══════════════════ */

export interface InboxMonitorMessage {
  id: string;
  fromUserId: string;
  fromUserName: string;
  toUserId: string;
  toUserName: string;
  subject: string;
  content: string;
  replies: {
    fromUserId: string;
    fromUserName: string;
    content: string;
    createdAt: string;
  }[];
  isRead: boolean;
  createdAt: string;
}

export async function fetchAllInboxMessages(limit = 200): Promise<InboxMonitorMessage[]> {
  const res = await apiClient.get('/api/v1/inbox/admin/all-messages', { params: { limit } });
  return res.data.data || [];
}

/* ═══════════════════ Helpers ═══════════════════ */

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}
